/**
 * Renders one JSON-LD node into <script type="application/ld+json">.
 *
 * `innerHTML` with JSON.stringify (matching the previous useBlogSeo pattern):
 * JSON.stringify escapes nothing that can break out of a script element except
 * `</script>` inside a string value, which the replace below neutralises.
 *
 * Multiple calls on one page produce multiple script tags. That is valid — the
 * `key` keeps Nuxt from deduplicating them into one.
 */
export function useJsonLd(
  node: MaybeRefOrGetter<Record<string, unknown> | null | undefined>,
  key: string,
) {
  useHead(() => {
    const value = toValue(node)
    if (!value) return {}
    return {
      script: [{
        key: `ld-${key}`,
        type: 'application/ld+json',
        innerHTML: JSON.stringify(value).replace(/<\/script/gi, '<\\/script'),
      }],
    }
  })
}
